export const gameConfig = ['i3', '5e', 'c4', '1s', '2p']; // spice

export const FIVE_LETTER_WORDS_LIST = [
  'APPLE',
  'BRAVE',
  'CHARM',
  'DANCE',
  'EAGER',
  'FLAME',
  'GRAPE',
  'HEART',
  'IVORY',
  'JOLLY',
  'KNEEL',
  'LIGHT',
  'MERRY',
  'NOBLE',
  'OCEAN',
  'PEACE',
  'QUILT',
  'REIGN',
  'SHINE',
  'TOWER',
  'ULTRA',
  'VIVID',
  'WHALE',
  'XENON',
  'YOUTH',
  'ZEBRA',
  'AMBER',
  'BLISS',
  'CRISP',
  'DREAM',
  'EAGLE',
  'FANCY',
  'GIANT',
  'HARSH',
  'INNER',
  'JOLLY',
  'KNOTY',
  'LEMON',
  'MAGIC',
  'NIFTY',
  'OASIS',
  'PLUCK',
  'QUEEN',
  'ROUGE',
  'SWING',
  'TREND',
  'UNITE',
  'VOICE',
  'WITTY',
  'ZESTY',
];
